// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Model-row specifics layered over the shared packageKind* row structure
   (ToolsMenuPackagePalette.module.css), the way AgentPaletteRow.module.css
   layers the agent row: a tinted avatar, a monospace id subtitle, and chips.
   One colour for every model, mixed from --curio-kind-model-fg and the on-dark
   text token the way the agent rows mix theirs, because this is a dark
   surface. */

.otLEZF29IzOTfH1zR3_Q {
  /* Inherit the avatar's colour (packageKindDragIcon pins a fixed light one). */
  font-size: 1.4em;
  color: inherit;
}

.EqOOHY25ju7ZriGxIngT {
  color: color-mix(in srgb, var(--curio-kind-model-fg) 45%, var(--curio-text-on-dark));
  background: color-mix(in srgb, var(--curio-kind-model-fg) 22%, transparent);
  border-color: color-mix(in srgb, var(--curio-kind-model-fg) 50%, transparent);
}

.dWTb1u8BartBESNK2C7T {
  background: color-mix(in srgb, var(--curio-kind-model-fg) 28%, transparent);
  color: color-mix(in srgb, var(--curio-kind-model-fg) 45%, var(--curio-text-on-dark));
}

.eVd1xzOlR1PI4_YnlJOr {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.Mk3q7lmtRFwISdYdru5h {
  font-family: "SFMono-Regular", ui-monospace, Menlo, Consolas, monospace;
  font-size: 9px;
  color: color-mix(in srgb, var(--curio-text-on-dark) 55%, transparent);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.teyrVDqOkbFbdgvKO5rw {
  flex-shrink: 0;
  align-self: center;
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/modelsPalette/ModelPaletteRow.module.css"],"names":[],"mappings":"AAAA;;;;;aAKa;;AAEb;EACE,8EAA8E;EAC9E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oFAAoF;EACpF,2EAA2E;EAC3E,6EAA6E;AAC/E;;AAEA;EACE,2EAA2E;EAC3E,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,uEAAuE;EACvE,cAAc;EACd,qEAAqE;EACrE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* Model-row specifics layered over the shared packageKind* row structure\n   (ToolsMenuPackagePalette.module.css), the way AgentPaletteRow.module.css\n   layers the agent row: a tinted avatar, a monospace id subtitle, and chips.\n   One colour for every model, mixed from --curio-kind-model-fg and the on-dark\n   text token the way the agent rows mix theirs, because this is a dark\n   surface. */\n\n.avatarIcon {\n  /* Inherit the avatar's colour (packageKindDragIcon pins a fixed light one). */\n  font-size: 1.4em;\n  color: inherit;\n}\n\n.avatar_model {\n  color: color-mix(in srgb, var(--curio-kind-model-fg) 45%, var(--curio-text-on-dark));\n  background: color-mix(in srgb, var(--curio-kind-model-fg) 22%, transparent);\n  border-color: color-mix(in srgb, var(--curio-kind-model-fg) 50%, transparent);\n}\n\n.chip_model {\n  background: color-mix(in srgb, var(--curio-kind-model-fg) 28%, transparent);\n  color: color-mix(in srgb, var(--curio-kind-model-fg) 45%, var(--curio-text-on-dark));\n}\n\n.pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.modelId {\n  font-family: \"SFMono-Regular\", ui-monospace, Menlo, Consolas, monospace;\n  font-size: 9px;\n  color: color-mix(in srgb, var(--curio-text-on-dark) 55%, transparent);\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.detailsButton {\n  flex-shrink: 0;\n  align-self: center;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarIcon": `otLEZF29IzOTfH1zR3_Q`,
	"avatar_model": `EqOOHY25ju7ZriGxIngT`,
	"chip_model": `dWTb1u8BartBESNK2C7T`,
	"pills": `eVd1xzOlR1PI4_YnlJOr`,
	"modelId": `Mk3q7lmtRFwISdYdru5h`,
	"detailsButton": `teyrVDqOkbFbdgvKO5rw`
};
export default ___CSS_LOADER_EXPORT___;
